// extracted by mini-css-extract-plugin
module.exports = {"box":"ExtraDimensionСard_box__-oOys","card":"ExtraDimensionСard_card__1PC6_","glow":"ExtraDimensionСard_glow__2hosJ","content":"ExtraDimensionСard_content__3QHdI"};